import { render, staticRenderFns } from "./acentekomisyon.vue?vue&type=template&id=50aebb52&"
import script from "./acentekomisyon.vue?vue&type=script&lang=js&"
export * from "./acentekomisyon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports